export const FirebaseConfig = {
    apiKey: "AIzaSyAL9_SCfMisIz7-kwV9ZBZzlG7y4lsGKdc",
    authDomain: "rayyan-h-tafe-nsw.firebaseapp.com",
    projectId: "rayyan-h-tafe-nsw",
    storageBucket: "rayyan-h-tafe-nsw.appspot.com",
    messagingSenderId: "579661195251",
    appId: "1:579661195251:web:107f8e4fcd7879c1c45486"
}

